
<template>
  <div class="fixed">
    <v-alert
      app
      v-if="company_data && company_data.status == 'blocked'"
      type="info"
      dense
      border="bottom"
      icon="mdi-timer-play-outline"
    >
      <strong>Atenção: </strong> - {{ msg }}
    </v-alert>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: 'FusionOnBlockedlMessage',
  data() {
    return {
      msg: "Sua conta está bloqueada. Consulte o seu gestor de conta.",
      // days: 7,
    };
  },
  methods: {
    
  },
  computed: {
    company_data() {
      if (this.oneUser && this.oneUser.company){
        return this.oneUser.company.data.attributes
      }
      return null 
    },
    ...mapState({
      oneUser: state => state.User.oneUser,
      // token_access_token: state => state.User.token_access_token,
      allSolutions: state => state.Solution.allSolutions,
      loading_solutions: state => state.Solution.loading_solutions
    })
  },
  watch: {
    
  },
};
</script>

<style scoped>
.fixed {
  position: relative;
  width: 100%;
  z-index: 1;
}
</style>
